import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Grid, styled, CircularProgress } from '@mui/material';
import Api from '../../Services/Api';

const StatCard = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    borderRadius: '8px',
    boxShadow: theme.shadows[1],
    transition: 'box-shadow 0.3s',
    '&:hover': {
        boxShadow: theme.shadows[2]
    }
}));

const StatsPanel = ({ sx }) => {
    const [countryCaps, setCountryCaps] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCountryCaps = async () => {
            try {
                setLoading(true);
                const response = await Api.getCountryCaps();
                if (response && response.success) {
                    setCountryCaps(response.data);
                } else {
                    setError('Failed to load country caps data');
                }
            } catch (err) {
                console.error('Error fetching country caps:', err);
                setError('Error loading country caps data');
            } finally {
                setLoading(false);
            }
        };

        fetchCountryCaps();
    }, []);

    if (loading) {
        return (
            <Box sx={{ ...sx, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ ...sx }}>
                <Typography variant="h6" gutterBottom sx={{ mb: 2, fontWeight: 'bold' }}>
                    Overview
                </Typography>
                <Typography color="error">{error}</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ ...sx }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 2, fontWeight: 'bold' }}>
                Overview
            </Typography>
            
            <Grid container spacing={2}>
                {Object.entries(countryCaps || {}).map(([country, countryData]) => {
                    // Safely destructure with defaults
                    const { total = 0, mobile = 0, desktop = 0 } = countryData || {};
                    const safeTotal = total || 0;
                    const mobilePercentage = safeTotal ? (mobile / safeTotal * 100) : 0;
                    const desktopPercentage = safeTotal ? (desktop / safeTotal * 100) : 0;

                    return (
                        <Grid item xs={12} sm={6} md={4} key={country}>
                            <StatCard>
                                <Typography variant="subtitle2" color="text.secondary">
                                    {country} Cap
                                </Typography>
                                <Typography variant="h5" sx={{ mt: 0.5 }}>
                                    {(safeTotal).toLocaleString()}
                                    <Typography component="span" variant="body2" color="text.secondary">
                                        {' '}/day
                                    </Typography>
                                </Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                                    {mobilePercentage.toFixed(1)}% Mobile • {desktopPercentage.toFixed(1)}% Desktop
                                </Typography>
                            </StatCard>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default StatsPanel; 